<script lang="ts" setup name="OrganisationPortCallsDetailsOverview">
import OrganisationPortCallsActivityWidgets from '~/components/OrganisationPortCallsActivityWidgets.vue';
import OrganisationPortCallsSchedule from '~/components/OrganisationPortCallsSchedule.vue';
import OrganisationPortCallsVoyageOverview from '~/components/OrganisationPortCallsVoyageOverview.vue';

defineProps<{
  organisationId: OrganisationId;
  portId: string;
  voyageId: string;
}>();
</script>

<template>
  <div class="space-y-2">
    <div class="grid-cols-2 gap-2 space-y-2 xl:grid xl:space-y-0">
      <div>
        <OrganisationPortCallsSchedule
          :organisationId="organisationId"
          :portCallId="portId"
          :voyageId="voyageId"
        />
      </div>

      <div>
        <OrganisationPortCallsVoyageOverview
          :organisationId="organisationId"
          :voyageId="voyageId"
          :portId="portId"
        />
      </div>
    </div>

    <OrganisationPortCallsActivityWidgets
      :organisationId="organisationId"
      :voyageId="voyageId"
      :portId="portId"
    />
  </div>
</template>
